import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xs leading-relaxed text-gray-500" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiSettingsRow = _resolveComponent("UiSettingsRow")!
  const _component_UiSettingsSection = _resolveComponent("UiSettingsSection")!

  return (_openBlock(), _createBlock(_component_UiSettingsSection, {
    title: $setup.t('whatsappMeta.quota.title'),
    footer: $setup.t('whatsappMeta.quota.footer')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_UiSettingsRow, {
        title: $setup.t('whatsappMeta.quota.rowTitle')
      }, {
        description: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _createTextVNode(_toDisplayString($setup.t('whatsappMeta.quota.rowDescription')) + " ", 1 /* TEXT */),
            _createElementVNode("a", {
              class: "text-primary font-medium underline",
              href: $setup.requestIncreaseUrl
            }, _toDisplayString($setup.t('whatsappMeta.quota.requestIncrease')), 9 /* TEXT, PROPS */, _hoisted_2)
          ])
        ]),
        action: _withCtx(() => [
          _createVNode(_component_UiBadge, {
            variant: "gray-100",
            "text-variant": "gray-700",
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.label), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]),
      _createVNode($setup["PhoneQuotaReachedNotice"], {
        full: $props.full,
        limit: $props.limit
      }, null, 8 /* PROPS */, ["full", "limit"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "footer"]))
}